/* eslint-disable no-undef */
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Controller, useForm } from 'react-hook-form'
import { loginFormScheme } from '../../../util/validationSchema'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { userLogin, verifyEmail } from '../../../redux/slices/authSlice' //userGoogleLogin, userFacebookLogin
import { PROJECT_TITLE } from '../../../util/constant'
import { MainLogo } from '../../../helper/imagepath' //HorizontalLine, Googgle, Facebook
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'
// import { useGoogleLogin } from '@react-oauth/google'
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
// import axios from 'axios'
import { getLocal } from '../../../helper/storage'
// import { Button } from 'reactstrap'

const Login = () => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Get search params
  const [searchParams] = useSearchParams()

  // Access token from query params
  const token = searchParams.get('token')

  const device_token = getLocal('device_token')

  useEffect(() => {
    if (token) {
      changeLoader(true)
      dispatch(verifyEmail(token)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Login successfully')
          changeLoader(false)
          // navigate('/')
        } else {
          errorToast(payload?.data?.status_message || error?.status_message)
          changeLoader(false)
        }
      })
    }
  }, [])

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(loginFormScheme)
  })

  const [eye, seteye] = useState(true)

  // const handleAuthResponse = async (data, serviceLogin) => {
  //   try {
  //     const { payload } = await dispatch(serviceLogin(data))

  //     if (payload?.status === 200) {
  //       navigate('/')
  //       successToast(payload?.data?.status_message || 'Success!')
  //     } else {
  //       errorToast(payload?.data?.status_message || 'Something went wrong')
  //     }
  //   } catch (error) {
  //     errorToast('An unexpected error occurred')
  //     console.error(error)
  //   } finally {
  //     changeLoader(false)
  //   }
  // }

  const submitLoginForm = (data) => {
    if (data) {
      changeLoader(true)
      dispatch(userLogin({ ...data, device_token: device_token })).then(({ payload }) => {
        if (payload?.status === 200) {
          navigate('/')
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
    // handleAuthResponse(data, userLogin)
  }

  // const login = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {
  //     changeLoader(true)
  //     try {
  //       const { data } = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
  //         headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
  //       })

  //       const payload = {
  //         google_id: data.sub,
  //         full_name: data.name,
  //         email: data.email
  //       }
  //       handleAuthResponse(payload, userGoogleLogin)
  //     } catch (error) {
  //       errorToast('Error fetching user information')
  //       console.error(error)
  //       changeLoader(false)
  //     }
  //   },
  //   onError: (error) => {
  //     errorToast('Google login failed')
  //     console.error(error)
  //   }
  // })

  // const handleFacebookResponse = (response) => {
  //   if (response.status !== 'unknown') {
  //     changeLoader(true)
  //     const payload = {
  //       facebook_id: response.id,
  //       full_name: response.name,
  //       email: response.email
  //     }
  //     handleAuthResponse(payload, userFacebookLogin)
  //   } else {
  //     errorToast('Facebook login failed')
  //     console.error('Facebook login failed')
  //   }
  // }

  // eslint-disable-next-line no-unused-vars
  const handleAppleResponse = (response) => {
    console.log('Apple login response:', response)
    // Handle the response here
  }

  const onEyeClick = () => seteye(!eye)

  return (
    <>
      <Helmet>
        <title>{PROJECT_TITLE}</title>
        <link rel="icon" href={''}></link>
      </Helmet>
      <div className="auth-wrapper-main">
        <div className="container ">
          <div className="authbox">
            <div className="auth-left">
              <div className="auth-page-title d-flex">
                Welcome to{' '}
                <img
                  // className="img-fluid logo-dark"
                  src={MainLogo}
                  onError={(event) => {
                    event.target.src = MainLogo
                  }}
                  alt="Logo"
                />
              </div>

              <div className="auth-form-content">
                <form onSubmit={handleSubmit(submitLoginForm)}>
                  <div className="form-group input_text">
                    <label className="form-control-label">
                      Email<span className="text-danger"> *</span>
                    </label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange }, fieldState }) => (
                        <>
                          <input
                            className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                            type="text"
                            value={value || ''}
                            autoComplete="false"
                            placeholder="Enter Email Address"
                            onChange={(val) => {
                              onChange(val)
                              trigger('email')
                            }}
                          />
                          <small>{fieldState?.error?.message}</small>
                        </>
                      )}
                    />
                  </div>
                  <div className="form-group input_text mb-2">
                    <label className="form-control-label">
                      Password<span className="text-danger"> *</span>
                    </label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange }, fieldState }) => (
                        <>
                          <div className="pass-group">
                            <input
                              type={eye ? 'password' : 'text'}
                              className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                              style={{
                                paddingRight: '36px'
                              }}
                              value={value || ''}
                              placeholder="✲ ✲ ✲ ✲"
                              autoComplete="false"
                              onChange={(val) => {
                                onChange(val)
                                trigger('password')
                              }}
                            />
                            <span onClick={onEyeClick} className={`fa toggle-password ${eye ? 'fa-eye-slash' : 'fa-eye'}`} />
                          </div>
                          <small>{fieldState?.error?.message}</small>
                        </>
                      )}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <div className="row">
                      <div className="col-12 text-end">
                        <Link className="forgot-link" to="/forgot-password">
                          {' '}
                          Forgot Password ?{' '}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-lg btn-block w-100 btn-primary" type="submit">
                    Log In
                  </button>
                </form>
                {/* <div className={`social_div`}>
                  <div className="divider_div">
                    <img src={HorizontalLine} width={155} height={1} alt="logo" />
                    <p className="common_para text-center mx-3">Or</p>
                    <img src={HorizontalLine} width={155} height={1} alt="logo" />
                  </div>
                  <div className="social_btn_main_div">
                    <FacebookLogin
                      // eslint-disable-next-line no-undef
                      appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
                      autoLoad={false}
                      fields="name,email,picture"
                      callback={handleFacebookResponse}
                      render={(renderProps) => (
                        <Button className="btn btn-primary paid-cancel-btn w-100 mb-3 auth-social-btn" onClick={renderProps.onClick}>
                          <img src={Facebook} alt="icon" /> <span>Continue With Facebook</span>
                        </Button>
                      )}
                    />
                    <Button className="btn btn-primary paid-cancel-btn w-100 auth-social-btn" onClick={() => login()}>
                      <img src={Googgle} alt="icon" /> <span>Continue With Google</span>
                    </Button>
                    <AppleLogin
                      clientId="YOUR_APPLE_CLIENT_ID"
                      redirectURI="YOUR_APPLE_REDIRECT_URI"
                      responseType="code"
                      responseMode="query"
                      usePopup={true}
                      callback={handleAppleResponse}
                      render={(renderProps) => (
                        <Button className="btn btn-primary paid-cancel-btn w-100 auth-social-btn" onClick={renderProps?.onClick}>
                          <img src={Apple} alt="icon" /> <span className="">Continue With Apple</span>
                        </Button>
                      )}
                      onSuccess={handleAppleResponse}
                      onFailure={handleError}
                    />
                  </div>
                </div> */}

                <div className="text-center dont-have mt-3">
                  {`Don’t have an account?`} <Link to="/register">Register</Link>
                </div>
              </div>
            </div>

            {/* <div className="auth-right auth-login-bg-img"></div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default Login
